import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Masked } from "work/_shared/masked-fields";
import WorkAgreement from "work/work-agreements/work-agreement";

const ComponentContainer = styled("div")(({ theme }) => ({
  height: "100%",
  margin: theme.spacing(2, 0, 4, 3),
}));
const DiscountText = styled(Typography)(({ theme }) => ({
  fontSize: "1.5em",
  marginTop: theme.spacing(1),
  color: theme.palette.text.secondary,
}));

type DiscountTabProps = {
  workAgreement: WorkAgreement;
};

export default function DiscountTab(props: Readonly<DiscountTabProps>) {
  const { workAgreement } = props;

  const discount = Masked.isPresentNotMasked(workAgreement.discount) ? workAgreement.discount.value : 0;

  if (Masked.isMasked(workAgreement.discount)) {
    return "You do not have permission to view the discount.";
  }

  return (
    <ComponentContainer>
      <DiscountText>{`${discount * 100}%`} discount</DiscountText>
    </ComponentContainer>
  );
}
